document.addEventListener("DOMContentLoaded", function () {
    const CART_ERASED_ON_THIS_SESSION_KEY = 'cartErasedOnThisSession';

    if(sessionStorage.getItem(CART_ERASED_ON_THIS_SESSION_KEY) === 'true'){
        return;
    }

    const PERFECT_PLAN_TEMPLATE_CLASS = 'template-full-pt-perfect-plan';
    const body = document.querySelector('body');

    if(!body.classList.contains(PERFECT_PLAN_TEMPLATE_CLASS)){
        return;
    }

    try {
        fetch('/cart/clear.js', {
          method: "POST",
        }).then((res)=>{
            if(res?.ok){
                console.log('Cart erased successfully')
                sessionStorage.setItem(CART_ERASED_ON_THIS_SESSION_KEY, true)
            }
        })
      } catch (error) {
        console.log(error);
      }
})